module.exports = __webpack_public_path__ + "img/folder24.ef008a3a.svg";